import {AIResourceSearch as AIResourceSearchFeature} from '@github-ui/ai-resource-search'
import type {AIResourceSearchError} from '@github-ui/ai-resource-search/types'
import {searchPath, type Query} from '@github-ui/paths'

import type {SearchKind, SearchKindCount} from '../hooks/use-search-result-counts'
import {useSoftNavigate} from '../hooks/use-soft-navigate'
import type {SearchResults} from '../types/blackbird-types'
import NoResults from './NoResults/NoResults'
import SearchError from './SearchError'
import CodeItemsSkeleton from './skeletons/CodeItemsSkeleton'

type AIResourceSearchProps = {
  counts: readonly SearchKindCount[]
  isLoadingCounters: boolean
  payload: SearchResults | null
  query: string
  resultKind: SearchKind
}

export function AIResourceSearch({counts, isLoadingCounters, payload, query, resultKind}: AIResourceSearchProps) {
  const navigateToPage = useSoftNavigate(searchPath)

  return (
    <AIResourceSearchFeature
      counts={counts}
      isLoadingCounters={isLoadingCounters}
      navigateToSearch={(searchQuery: Query) => navigateToPage(undefined, searchQuery)}
      payload={payload}
      query={query}
      renderError={(error: AIResourceSearchError, index: number) => <SearchError error={error} index={index} />}
      renderLoadingResults={() => <CodeItemsSkeleton />}
      renderNoResults={() => (
        <NoResults resultKind={resultKind} searchKinds={[...counts]} isLoadingCounters={isLoadingCounters} />
      )}
      resultKind={resultKind}
    />
  )
}
